import { DEVICE_TYPE } from '../constants'
import { prepareTypes } from './root-service'

import featureTogglingActions from 'containers/FeatureToggling/services/featureToggling-actions'
import firmwaresActions from 'containers/Firmwares/services/firmwares-actions'
import firmwareUpdateActions from 'containers/FirmwareUpdateSchedule/services/firmwareUpdate-actions'
import organizationActions from 'containers/Organizations/services/organization-actions'
import { LOAD_USERS_SUCCESS } from 'containers/Users/services/users-actions'
import forEach from 'lodash/forEach'
import toUpper from 'lodash/toUpper'
import { createReducer } from 'redux-act'
import rootActions from './root-actions'

const initialState = {
  isLoading: false,
  devicesTypes: [] as { label: string; value: string }[],
  networkError: false,
}

export const rootReducer = createReducer(
  {
    [rootActions.actionTypes.SET_NETWORK_ERROR]: (state, payload) => {
      const { isOnline } = payload.isOnline

      return {
        ...state,
        networkError: !isOnline,
      }
    },
    [firmwareUpdateActions.actionTypes.LOAD_DEVICES_SUCCEEDED]: (
      state,
      payload
    ) => {
      return {
        ...state,
        networkError: false,
      }
    },
    [organizationActions.actionTypes.LOAD_ORGANIZATIONS_SUCCEEDED]: (
      state,
      payload
    ) => {
      return {
        ...state,
        networkError: false,
      }
    },
    [LOAD_USERS_SUCCESS.getType()]: (state, payload) => {
      return {
        ...state,
        networkError: false,
      }
    },
    [firmwaresActions.actionTypes.LOAD_FIRMWARES_SUCCESS]: (state, payload) => {
      return {
        ...state,
        networkError: false,
      }
    },
    [featureTogglingActions.actionTypes.GET_FEATURES_SUCCEEDED]: (
      state,
      payload
    ) => {
      return {
        ...state,
        networkError: false,
      }
    },
    [rootActions.actionTypes.LOAD_DEVICES_TYPES_SUCCEEDED]: (
      state,
      payload
    ) => {
      const { types } = payload

      forEach(types, (type) => {
        if (type.displayValue === toUpper(DEVICE_TYPE.FAR_UVC.label)) {
          type.value = DEVICE_TYPE.FAR_UVC.type
        }
      })

      return {
        ...state,
        devicesTypes: prepareTypes(types),
      }
    },
    [rootActions.actionTypes.LOAD_SUB_TYPES_FOR_DEVICE_SUCCEEDED]: (
      state,
      payload
    ) => {
      return {
        ...state,
        subTypesForDevice: prepareTypes(payload.subTypes),
      }
    },
  },

  initialState
)
